import React from 'react';
import OverallCanvasGraph from './OverallGraph';
import MainGraph from './ChapterWiseGraph';

function ESGResult(props) {
  return (
    <div>
      <OverallCanvasGraph {...props} />
      <MainGraph {...props} />
    </div>
  );
}

export default ESGResult;



// WEBPACK FOOTER //
// ./src/views/ESG/CBT/ResultGraph/index.jsx